export default __webpack_public_path__ + "static/media/arrow_up.3a8fd357.svg";